// includes new-match, notify, external, not-found

import { LocaleCommon } from '../en/common'

const common: LocaleCommon = {
  addMatches: 'Thêm Trận Đấu',
  editMatch: 'Chỉnh Sửa Trận Đấu',
  deleteMatch: 'Xóa Trận Đấu',
  deleteMatchDesc:
    'Bạn có chắc chắn muốn xóa trận đấu này không? Khi đã xóa, bạn không thể khôi phục lại và nó sẽ bị xóa khỏi hồ sơ người chơi và từ trang trận đấu của câu lạc bộ.',
  externalMatchManaged:
    'Trận đấu này đã được tải lên trên một nền tảng bên ngoài và phải được chỉnh sửa hoặc xóa tại đó.',
  oldPass: 'Mật Khẩu Cũ',
  newPass: 'Mật Khẩu Mới',
  confirmPass: 'Xác Nhận Mật Khẩu',
  save: 'Lưu',
  firstName: 'Tên',
  lastName: 'Họ',
  location: 'Địa Điểm',
  yourBirthday: 'Ngày Sinh Của Bạn',
  birthday: 'Ngày Sinh',
  birthDateMin: 'Để tạo tài khoản cho người dùng dưới 13 tuổi, vui lòng điền vào biểu mẫu bên dưới:',
  under13AccountCreationForm: 'Biểu mẫu yêu cầu tạo tài khoản',
  gender: 'Giới Tính',
  phone: 'Điện Thoại',
  yourPhone: 'Điện Thoại Của Bạn',
  congrats: 'Chúc Mừng!',
  error: 'Lỗi',
  search: 'Tìm Kiếm',
  filters: 'Bộ Lọc',
  apply: 'Áp Dụng',
  clearAll: 'Xóa Tất Cả',
  distance: 'Khoảng Cách',
  noLimit: 'Không Giới Hạn',
  man: 'Nam',
  woman: 'Nữ',
  anybody: 'Bất Kỳ Ai',
  men: 'Đàn Ông',
  women: 'Phụ Nữ',
  type: 'Loại',
  doubles: 'Đôi',
  singles: 'Đơn',
  Doubles: 'Đôi',
  Singles: 'Đơn',
  Any: 'Bất kì',
  duprRating: 'Xếp Hạng DUPR',
  ageRange: 'Khoảng Tuổi',
  minAge: 'Tuổi Tối Thiểu',
  maxAge: 'Tuổi Tối Đa',
  under19: 'Dưới 19',
  share: 'Chia Sẻ',
  message: 'Tin Nhắn',
  email: 'Email',
  emailPlaceHolder: 'Nhập Email',
  confirmEmail: 'Xác Nhận Email',
  confirmEmailPlaceHolder: 'Nhập Xác Nhận Email',
  password: 'Mật Khẩu',
  passwordPlaceHolder: 'Nhập Mật Khẩu',
  confirmPassword: 'Xác Nhận Mật Khẩu',
  confirmPasswordPlaceHolder: 'Nhập Xác Nhận Mật Khẩu',
  fullName: 'Tên Đầy Đủ',
  fullNamePlaceHolder: 'Nhập Tên Đầy Đủ',
  birthDate: 'Ngày Sinh',
  birthDatePlaceHolder: 'Chọn Ngày Sinh',
  phonePlaceHolder: 'Nhập Số Điện Thoại',
  continue: 'Tiếp Tục',
  selectCountry: 'Chọn Quốc Gia',
  submit: 'Gửi',
  forgotPassword: 'Quên Mật Khẩu',
  cancel: 'Hủy',
  textDigitCode: 'Nhập Mã 4 Số Của Bạn',
  resend: 'Gửi Lại',
  verify: 'Xác Minh',
  noMoreResults: 'Không còn kết quả.',
  contactSupport: 'Liên Hệ Hỗ Trợ',
  viewAll: 'Xem Tất Cả',
  payments: 'Thanh Toán',
  setUpPayments: 'Thiết Lập Thanh Toán',
  details: 'Chi Tiết',
  navigate: 'Điều Hướng',
  member: 'Thành Viên',
  members: 'Các Thành Viên',
  exportCSV: 'Xuất CSV',
  exportFailed: 'Chúng tôi không thể xuất danh sách thành viên. Vui lòng thử lại.',
  exportTimedOut: 'Quá trình xuất đang mất nhiều thời gian hơn dự kiến. Vui lòng thử lại sau ít phút.',
  exportConnectionLost: 'Mất kết nối trong khi chuẩn bị tệp xuất. Vui lòng thử lại.',
  downloadCSVDesc: 'Tải mẫu CSV của chúng tôi để tạo lời mời hàng loạt bằng email.',
  downloadCSVNote: 'LƯU Ý: Bạn cần xóa tiêu đề của tệp CSV',
  learnMore: 'Tìm Hiểu Thêm',
  downloadTemplate: 'Tải Mẫu',
  dragFile: 'Kéo tệp CSV của bạn vào đây hoặc',
  browseFile: 'Duyệt Tệp',
  removeFile: 'Xóa Tệp',
  matches: 'Các Trận Đấu',
  match: 'Trận Đấu',
  sort: 'Sắp Xếp',
  newToOld: 'Mới Nhất Đến Cũ Nhất',
  oldToNew: 'Cũ Nhất Đến Mới Nhất',
  clearFilters: 'Xóa Bộ Lọc',
  matchId: 'Mã Trận Đấu:',
  reUpload: 'Tải Lại',
  events: 'Sự Kiện',
  deleteEvent: 'Xóa Sự Kiện',
  deleteEventDesc: 'Xóa sự kiện này cũng sẽ xóa các nhánh liên quan. Xác nhận để xóa sự kiện này.',
  confirm: 'Xác Nhận',
  delete: 'Xóa',
  registeredPlayers: 'Người Chơi Đã Đăng Ký',
  upcoming: 'Sắp Diễn Ra',
  draft: 'Nháp',
  open: 'Mở',
  ongoing: 'Đang Diễn Ra',
  completed: 'Hoàn Thành',
  logo: 'Logo',
  eventLogo: 'Logo Sự Kiện',
  eventName: 'Tên Sự Kiện',
  registration_url: 'Registration URL',
  summary: 'Tóm Tắt',
  whatAreTheDetails: 'Chi Tiết Là Gì?',
  entryFee: 'Phí Tham Gia',
  entryFeeDesc: 'Người chơi sẽ trả phí này ngoài phí nhánh. Bạn có thể thiết lập giá phí cho mỗi nhánh sau.',
  memberPrice: 'Giá Thành Viên',
  nonMemberPrice: 'Giá Không Phải Thành Viên',
  policies: 'Chính Sách',
  uploadWaiver: 'Tải Lên Miễn Trách',
  uploadWaiverDesc: 'DUPR khuyến khích các sự kiện bao gồm miễn trách nghĩa vụ.',
  liabilityWaiver: 'Miễn Trách Nghĩa Vụ',
  refundPolicy: 'Chính Sách Hoàn Tiền',
  refundPolicyDesc:
    'Người đăng ký sẽ nhận được hoàn tiền toàn phần hoặc một phần nếu họ hủy trước khi sự kiện bắt đầu? Họ sẽ nhận được hoàn tiền một phần nếu hủy sau khi liên đoàn bắt đầu?',
  healthPolicy: 'Chính Sách Sức Khỏe',
  healthPolicyDesc: 'Liên đoàn của bạn có quy tắc cụ thể về sức khỏe và an toàn của người tham gia không?',
  bracket: 'Nhánh',
  brackets: 'Các Nhánh',
  addBracket: 'Thêm Nhánh',
  select: 'Chọn',
  playerGroup: 'Nhóm Người Chơi',
  format: 'Định Dạng',
  ratingRange: 'Xếp Hạng Tuổi',
  minimum: 'Tối Thiểu',
  maximum: 'Tối Đa',
  name: 'Tên',
  bracketName: 'Tên Nhánh',
  autoGenerate: 'Tự Động Tạo',
  courts: 'Sân',
  courtsDesc: 'Số Sân (Tối Thiểu 1 và Tối Đa 8)',
  maxTeams: 'Số Đội Tối Đa',
  maxTeamsDec: 'Có bao nhiêu đội sẽ tham gia sự kiện?',
  waitList: 'Danh Sách Chờ',
  waitListDesc: 'Bạn muốn cho phép bao nhiêu đội tham gia danh sách chờ?',
  registration: 'Đăng Ký',
  registrationDesc: 'Thiết lập thời gian đăng ký cho người chơi',
  startDateTime: 'Ngày & Giờ Bắt Đầu',
  endDateTime: 'Ngày & Giờ Kết Thúc',
  competition: 'Cuộc Thi',
  competitionDesc: 'Thiết lập ngày và giờ cho cuộc thi của nhánh này',
  timeZone: 'Múi Giờ',
  price: 'Giá',
  priceDesc: 'Người chơi sẽ trả giá này cùng với phí tham gia',
  selectAnImage: 'Chọn ảnh để tải lên',
  loadingImage: 'Đang tải ảnh...',
  chooseFile: 'Chọn Tập Tin',
  invite: 'Mời',
  optional: '(Không bắt buộc)',
  messageAndDataRatesMayApply: 'Có thể áp dụng cước phí tin nhắn và dữ liệu.',
  sendInvite: 'Gửi Lời Mời',
  invites: 'Lời Mời',
  requests: 'Yêu Cầu',
  invited: 'Đã Mời',
  ignoreAll: 'Bỏ Qua Tất Cả',
  acceptAll: 'Chấp Nhận Tất Cả',
  ignore: 'Bỏ Qua',
  cancelInvite: 'Hủy Lời Mời',
  address: 'Địa Chỉ',
  addNew: 'Thêm Mới',
  mi: 'Mi',
  startsIn: 'Bắt Đầu Trong',
  endsIn: 'Kết Thúc Trong',
  downloadLiabilityWaiver: 'Tải Xuống Miễn Trách Nhiệm',
  healthSafetyPolicy: 'Chính Sách Sức Khỏe & An Toàn',
  yes: 'Có',
  no: 'Không',
  addPartner: 'Thêm Đối Tác',
  addPartnerNote: 'Bạn cũng có thể chờ đến sau khi đăng ký để thêm đối tác',
  ok: 'OK',
  success: 'Thành Công',
  failure: 'Thất Bại',
  signUpOrLogin: 'Đăng Ký hoặc Đăng Nhập để xem thông tin này',
  accept: 'Chấp Nhận',
  goBack: 'Quay Lại',
  with: 'với',
  game: 'Trò Chơi',
  highToLowRating: 'Xếp Hạng Cao đến Thấp',
  lowToHighRating: 'Xếp Hạng Thấp đến Cao',
  add: 'Thêm',
  confirmation: 'Xác Nhận',
  back: 'Trở Lại',
  next: 'Tiếp Theo',
  saveChanges: 'Lưu Thay Đổi',
  sortingRules: 'Quy Tắc Sắp Xếp',
  sortingRulesDesc:
    'Các đội được sắp xếp theo xếp hạng trung bình. Xếp hạng đã xác minh được coi trọng hơn so với xếp hạng tạm thời. Người chơi có xếp hạng NR được coi là có xếp hạng 2.00.',
  create: 'Tạo',
  matchDate: 'Ngày Trận Đấu',
  time: 'Thời Gian',
  connectWith: 'Kết Nối Với',
  externalApplication: 'Xếp hạng pickleball chính xác nhất thế giới',
  externalLoginCheckbox:
    'Cho phép DUPR tạo một phiên mới cho trang web này bằng cách sử dụng quyền truy cập chỉ đọc, tất cả dữ liệu của tôi sẽ được bảo vệ và an toàn',
  logging: 'Đang Đăng Nhập...',
  login: 'Đăng Nhập',
  saveMatch: 'Lưu Trận Đấu',
  submitMatches: 'Nộp Các Trận Đấu',
  confirmSubmitMatches: 'Các trận đấu này sẽ được nộp và xếp hạng người chơi sẽ được cập nhật ngay sau đó.',
  event: 'Sự Kiện',
  eventPlaceHolder: 'Tên Sự Kiện',
  date: 'Ngày',
  checkboxAddYourSelf: 'Thêm bản thân vào trận đấu này?',
  team1: 'Đội 1',
  team2: 'Đội 2',
  searchPlayer: 'Tìm Người Chơi',
  score: 'Điểm Số',
  standard: 'Tiêu Chuẩn',
  rally: 'Rally',
  warning: 'WARNING',
  reset: 'Reset',
  game1: 'Trò Chơi 1',
  game2: 'Trò Chơi 2',
  game3: 'Trò Chơi 3',
  game4: 'Trò Chơi 4',
  game5: 'Trò Chơi 5',
  addAnotherMatch: 'Thêm Trận Đấu Khác',
  oops: 'Ôi!',
  venturedPath: 'Bạn đã đi lạc khỏi con đường.',
  redirectedDashboard: 'Bạn sẽ được chuyển hướng đến Bảng Điều Khiển trong',
  seconds: 'giây',
  DUPRIDCopied: 'Đã Sao Chép DUPRID!',
  copyClipboard: 'Sao chép vào bảng tạm',
  myAccount: 'Tài Khoản Của Tôi',
  editProfile: 'Chỉnh Sửa Hồ Sơ',
  passwordSecurity: 'Mật Khẩu và Bảo Mật',
  infoSupport: 'Thông Tin và Hỗ Trợ',
  support: 'Hỗ Trợ',
  runEvents: 'Tổ Chức Sự Kiện',
  FAQs: 'Câu Hỏi Thường Gặp',
  termsUse: 'Điều Khoản Sử Dụng',
  privacyPolicy: 'Chính Sách Bảo Mật',
  logout: 'Đăng Xuất',
  Members: 'Thành viên',
  Matches: 'Trận đấu',
  Events: 'Sự kiện',
  Invites: 'Lời mời',
  Queue: 'Xếp hàng',
  Standings: 'Bảng xếp hạng',
  Players: 'Người chơi',
  Teams: 'Đội',
  UnmatchedPlayer: 'Người chơi chưa từng có',
  Payments: 'Thanh toán',
  performance: 'Hiệu suất',
  myPerformance: 'My Performance',
  newMatch: 'Tạo trận đấu',
  players: 'Người chơi',
  clubs: 'Nhóm',
  Week: 'Tuần',
  Month: 'Tháng',
  RoundRobin: 'Round Robin',
  Waterfall: 'Waterfall',
  FlexLeague: 'Flex League',
  Mixed: 'Mixed',
  Open: 'Mở cửa',
  Men: 'Nam',
  Women: 'Nữ',
  ViewAll: 'Xem Tất cả',
  Round: 'Vòng',
  Round1: 'Vòng 1',
  Round2: 'Vòng 2',
  Round3: 'Vòng 3',
  Round4: 'Vòng 4',
  Round5: 'Vòng 5',
  Round6: 'Vòng 6',
  Round7: 'Vòng 7',
  Round8: 'Vòng 8',
  Round9: 'Vòng 9',
  Round10: 'Vòng 10',
  Dashboard: 'Bảng điều khiển',
  SearchPlayer: 'Tìm Người Chơi',
  SearchEvents: 'Tìm Sự Kiện',
  Rankings: 'Bảng Xếp Hạng',
  Genie: 'Genie',
  Shops: 'Cửa Hàng',
  HowItWorks: 'Cách Hoạt Động',
  RunEvents: 'Tổ Chức Sự Kiện',
  CollegiatePickleball: 'Pickleball Đại Học',
  News: 'Tin Tức',
  LogIn: 'Đăng Nhập',
  SignUp: 'Đăng Ký',
  decline: 'Từ Chối',
  savePublish: 'Lưu & Xuất Bản',
  publish: 'Xuất Bản',
  publishing: 'Đang Xuất Bản',
  upload: 'Tải Lên',
  signUpLogin: 'Đăng ký hoặc Đăng nhập',
  January: 'Tháng Một',
  February: 'Tháng Hai',
  March: 'Tháng Ba',
  April: 'Tháng Tư',
  May: 'Tháng Năm',
  June: 'Tháng Sáu',
  July: 'Tháng Bảy',
  August: 'Tháng Tám',
  September: 'Tháng Chín',
  October: 'Tháng Mười',
  November: 'Tháng Mười Một',
  December: 'Tháng Mười Hai',
  following: 'Đang Theo Dõi',
  followers: 'Người Theo Dõi',
  rating: 'Xếp Hạng',
  MatchDate: 'Ngày Thi Đấu',
  CreatedDate: 'Ngày Tạo',
  ModifiedDate: 'Ngày Chỉnh Sửa',
  follow: 'Theo Dõi',
  unFollow: 'Bỏ Theo Dõi',
  noFollowing: 'Người chơi này chưa theo dõi ai',
  noFollower: 'Người chơi này chưa có người theo dõi',
  notFollowing: 'Người chơi này chưa theo dõi ai',
  home: 'Trang Chủ',
  removeConfirm: 'Bạn có chắc chắn muốn xóa mục này không?',
  edit: 'Chỉnh Sửa',
  play: 'Chơi',
  invitePlayerSuccess: 'Mời người chơi thành công',
  createAMatch: 'Tạo Trận Đấu',
  marketingAssets: 'Tài Nguyên Tiếp Thị',
  settings: 'Cài Đặt',
  compliantText:
    'Bằng cách chọn hộp này, bạn đồng ý nhận thêm thông tin về cập nhật sản phẩm, sự kiện, tin tức và ưu đãi của chúng tôi',
  communityGuidelines: 'Nguyên Tắc Cộng Đồng',
  minorLeaguePickleball: 'Giải Đấu Nhỏ',
  collegiatePickleball: 'Pickleball Đại Học',
  blog: 'Blog',
  playerName: 'Tên Người Chơi',
  matchOwner: 'Chủ Trận Đấu',
  hasVerifiedMatch: 'Người chơi đã xác minh trận đấu',
  privacy: 'Sự riêng tư',
  displayAge: 'Hiển thị tuổi',
  displayLocation: 'Hiển thị vị trí',
  hideAge: 'Ẩn tuổi',
  hideLocation: 'Ẩn vị trí',
  addMembers: 'Thêm Thành Viên Nhóm',
  messages: 'Tin nhắn',
  verifyEmail: 'Xác minh Email của bạn',
  mustVerify: 'Bạn phải xác minh email của mình để truy cập tính năng này.',
  clickResendLink: 'Nhấn "gửi lại liên kết" để nhận liên kết xác minh.',
  changeEmail: 'Bạn có muốn thay đổi email của mình không?',
  alreadyVerified: 'Đã xác minh',
  resendLink: 'Gửi lại liên kết',
  aLinkWasSent: 'Một liên kết đã được gửi đến email mới của bạn!',
  removed: 'Đã xóa',
  today: 'Hôm nay',
  yesterday: 'Hôm qua',
  firstNamePlaceHolder: 'Nhập Tên',
  lastNamePlaceHolder: 'Nhập Họ',
  doNotTrack: 'Không theo dõi',
  allowTracking: 'Cho phép theo dõi',
  allowTargetedAds: 'Cho phép quảng cáo được nhắm mục tiêu',
  disallowTargetedAds: 'Không cho phép quảng cáo được nhắm mục tiêu',
  subscriptions: 'Đăng ký',
  haveActiveSubscription: 'Bạn có một đăng ký hoạt động.',
  toManageSubscription: 'Để quản lý đăng ký của bạn, vui lòng',
  visitThisLinkTo: 'Truy cập liên kết này để',
  subscriptionStatus: 'Trạng thái đăng ký',
  manageSubscription: 'Quản lý đăng ký',
  and: 'và',
  phoneVerify:
    'Bằng cách nhập số điện thoại di động của tôi, tôi đồng ý nhận tin nhắn văn bản để xác minh tài khoản và xác thực hai yếu tố (2FA). Có thể áp dụng cước phí tin nhắn và dữ liệu tiêu chuẩn. Những tin nhắn này chỉ được sử dụng để giúp bảo mật tài khoản của tôi và xác minh danh tính của tôi và không dùng cho mục đích tiếp thị',
  phoneOptInRequired:
    'Bạn phải đồng ý với việc chọn nhận tin nhắn văn bản để xác minh tài khoản và xác thực hai yếu tố ở trên.',

  verifyYourPhone: 'Xác minh số điện thoại của bạn',
  sentCodeTo: 'Chúng tôi đã gửi mã đến {{phone}}',
  sendCodeTo: 'Gửi mã đến {{phone}}',
  phoneVerified: 'Số điện thoại đã được xác minh',
  youreAllSet: 'Bạn đã sẵn sàng.',
  sending: 'Đang gửi...',
  sendCode: 'Gửi mã',
  verifying: 'Đang xác minh...',
  resendIn: 'Gửi lại trong {{s}} giây',
  resendCode: 'Gửi lại mã',
  otpDisclaimer: 'Có thể áp dụng phí tin nhắn tiêu chuẩn.',
  invalidCode: 'Mã không hợp lệ, vui lòng thử lại.',
  genericError: 'Đã xảy ra lỗi. Vui lòng thử lại.',
  phoneMissing: 'Không có số điện thoại để xác minh.',
  verifyingNumber: 'Đang xác minh số',
  iso: 'ISO',
  changeNumber: 'Thay đổi số',
}

export default common
